/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    SAVE: 'Guardar'
  },
  ERROR: {},
  HEADER: {
    LINK: 'Enlace',
    SOCIAL_NETWORK: 'Red social',
    USERNAME: 'Nombre de usuario'
  },
  LABEL: {
    CREATE_LINK: 'Añadir red social',
    EDIT_LINK: 'Editar red social',
    INACTIVATE_LINK: 'Eliminar red social',
    INACTIVATE_LINK_MODAL_TITLE: 'Eliminar red social',
    LINK: 'Enlace',
    SOCIAL_NETWORK: 'Red social',
    USERNAME: 'Nombre de usuario'
  },
  SENTENCE: {
    ERROR: 'Error',
    INACTIVATE_LINK_TEXT: '¿Seguro que quieres eliminar esta red social?',
    NO_ROWS_LINKS: 'Sin redes sociales'
  },
  SUCCESS: {
    LINKS_DETAILS_INACTIVATE: 'La red social se ha eliminada correctamente',
    LINKS_DETAILS_SAVED: 'La red social se ha guardado correctamente',
    LINKS_DETAILS_UPDATED: 'La red social se ha actualizado correctamente',
    SUCCESS: 'Éxito'
  },
  TOOLTIP: {
    LINK: 'Enlace',
    SOCIAL_NETWORK: 'Red social',
    USERNAME: 'Nombre de usuario'
  }
};
